import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
import n from "../../../../_virtual/_plugin-vue_export-helper.js";
const r = {}, a = {
  fill: "none",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
function c(f, e) {
  return o(), l("svg", a, [...e[0] || (e[0] = [
    t("rect", {
      fill: "#C61716",
      height: "20",
      rx: "4",
      width: "20"
    }, null, -1),
    t("path", {
      "clip-rule": "evenodd",
      d: "M13.487 5h1.842c.32 0 .58.26.58.581v1.842c0 .32-.26.581-.58.581h-1.842a.581.581 0 0 1-.581-.581V5.58c0-.32.26-.581.581-.581Zm-2.21.78H4.767a.39.39 0 0 1 0-.78h6.512a.39.39 0 0 1 0 .78Zm-6.511 2.2h6.512a.39.39 0 0 0 0-.78H4.766a.39.39 0 1 0 0 .78Zm0 2.2h10.753a.39.39 0 1 0 0-.78H4.766a.39.39 0 1 0 0 .78Zm0 4.4h10.753a.39.39 0 0 0 0-.78H4.766a.39.39 0 1 0 0 .78Zm10.753-2.2H4.766a.39.39 0 0 1 0-.78h10.753a.39.39 0 0 1 0 .78Z",
      fill: "#fff",
      "fill-rule": "evenodd"
    }, null, -1)
  ])]);
}
const h = /* @__PURE__ */ n(r, [["render", c]]);
export {
  h as default
};
